import { useEffect, useState } from 'react';
import { loginAdmin } from '../api/adminAuth';
import { getApiErrorMessage } from '../api/client';
import {
  ADMIN_AUTH_EXPIRED_EVENT,
  isAdminAuthenticated,
  isAdminToken,
  setAdminToken,
} from '../config/adminAuth';
import { useI18n } from '../i18n';

function AdminGate({ children, title }) {
  const { t } = useI18n();
  const [authenticated, setAuthenticated] = useState(isAdminAuthenticated);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // API 가 401 을 돌려주면 (토큰 만료) 로그인 화면으로
  useEffect(() => {
    const onExpired = () => {
      setAuthenticated(false);
      setError(t('admin.gate.expired'));
    };
    window.addEventListener(ADMIN_AUTH_EXPIRED_EVENT, onExpired);
    return () => window.removeEventListener(ADMIN_AUTH_EXPIRED_EVENT, onExpired);
  }, [t]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (!email.trim() || !password) {
      setError(t('admin.gate.required'));
      return;
    }

    setSubmitting(true);
    try {
      const { token } = await loginAdmin(email.trim(), password);
      if (!token || !isAdminToken(token)) {
        setError(t('admin.gate.adminOnly'));
        return;
      }
      setAdminToken(token);
      setAuthenticated(true);
      setPassword('');
    } catch (err) {
      setError(getApiErrorMessage(err, t('admin.gate.failed')));
    } finally {
      setSubmitting(false);
    }
  };

  if (authenticated) {
    return children;
  }

  return (
    <div className="admin-gate">
      <div className="admin-gate-card">
        <p className="admin-gate-eyebrow">ADMIN ACCESS</p>
        <h2 className="admin-gate-title">{title ?? t('admin.gate.defaultTitle')}</h2>
        <p className="admin-gate-desc">
          {t('admin.gate.desc1')}
          <br />
          {t('admin.gate.desc2')}
        </p>
        <form className="admin-gate-form" onSubmit={handleSubmit}>
          <label className="form-label" htmlFor="admin-email">
            {t('admin.gate.email')}
          </label>
          <input
            id="admin-email"
            type="email"
            className="form-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@example.com"
            autoComplete="username"
            autoFocus
          />
          <label className="form-label" htmlFor="admin-password">
            {t('admin.gate.password')}
          </label>
          <input
            id="admin-password"
            type="password"
            className="form-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t('admin.gate.passwordPlaceholder')}
            autoComplete="current-password"
          />
          {error && <p className="admin-gate-error">{error}</p>}
          <button type="submit" className="btn btn-next admin-gate-submit" disabled={submitting}>
            {submitting ? t('admin.gate.loggingIn') : t('admin.gate.login')}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminGate;
